"use client"
import { HeroUIProvider } from "@heroui/react"
import { useRouter } from "next/navigation"
import { ThemeProvider } from "next-themes"
import React from "react"
import { IsClientCtxProvider } from "@/contexts/isClientContext"
import { ZodTranslationProvider } from "@/contexts/zodI18nProvider"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { Toaster } from "react-hot-toast"
import { ConfettiCtxProvider } from '@/contexts/confettiContext'
import { Settings } from "luxon"
import { useLocale } from "next-intl"

const queryClient = new QueryClient()

export function ClientProviders({
  children
}: {
  children: React.ReactNode
}) {
  const router = useRouter()
  const locale = useLocale()
  Settings.defaultLocale = locale
  return (
    <HeroUIProvider navigate={router.push}>
      <ThemeProvider attribute="class" defaultTheme="dark" enableSystem={false}>
        <IsClientCtxProvider>
          <ConfettiCtxProvider>
            <ZodTranslationProvider>
              <Toaster />
              <QueryClientProvider client={queryClient}>
                {children}
              </QueryClientProvider>
            </ZodTranslationProvider>
          </ConfettiCtxProvider>
        </IsClientCtxProvider>
      </ThemeProvider>
    </HeroUIProvider>
  )
}
